<template>
    <vue-scroll>
        <div class="page-contacts flex column scrollable only-y mb-20" id="page-contacts"
            v-show="userPermissionsFilter.admin" v-loading="pageLoading" :element-loading-text="loadingText"
            element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
            <resize-observer @notify="__resizeHanlder" />

            <div class="page-exchangerates flex column mb-20">
                <div class="page-header">
                    <h1 class="pageTitle">Collection Mode Details</h1>
                </div>

                <div class="mt-0 w-100">
                    <div style="float: right;">
                        <el-button type="primary" icon="el-icon-plus" @click="addProvider">Add New</el-button>
                    </div>
                </div>


                <div class="mt-10">
                    <resize-observer @notify="handleResize" />
                    <div class="table-responsive">
                        <table class="table" id="datatable" style="color:white;">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Code</th>
                                    <th>Currency</th>
                                    <th>Synonym</th>
                                    <th>Company</th>
                                    <th>Country</th>
                                    <th>Account</th>
                                    <th>Type</th>
                                    <th>BO</th>
                                    <th>Webapp</th>
                                    <th>Mobile</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in collectionModesData" :key="item.id">
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.code }}</td>
                                    <td>{{ item.currency }}</td>
                                    <td>{{ item.synonym }}</td>
                                    <td>{{ item.companyName }}</td>
                                    <td>{{ item.countryName }}</td>
                                    <td>{{ item.accountNumber }}</td>
                                    <td>{{ item.type }}</td>
                                    <td><span v-if="item.backofficeUse">Active</span> <span v-else>Dormant</span></td>
                                    <td><span v-if="item.webappUse">Active</span> <span v-else>Dormant</span></td>
                                    <td><span v-if="item.mobileUse">Active</span> <span v-else>Dormant</span></td>
                                    <td><el-button type="primary" icon="el-icon-edit"
                                            @click="editProvider(item)">EDIT</el-button></td>
                                    <td>
                                        <el-button type="primary" @click="deleteCollectionModes(item.id)"><i
                                                class="mdi mdi-check-circle"></i> Delete</el-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>


                    <el-dialog :show-close="true" :custom-class="'user-dialog'" :visible="dialogFormVisible"
                        @close="closeDialog" :before-close="handleClose">
                        <div class="form-box">
                            <div class="row">
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Name</strong>
                                        <el-input placeholder="Name" v-model="this.editCollections.name" name="name"
                                            v-validate="'required'" data-vv-as="name"></el-input>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('name') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Code</strong>
                                        <el-input placeholder="Code" v-model="this.editCollections.code" name="code"
                                            v-validate="'required'" data-vv-as="code"></el-input>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('code') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Currency</strong>
                                        <el-select v-model="this.editCollections.currency" filterable clearable
                                            placeholder="Currency" class="mb-10" style="width:100%" name="currency"
                                            v-validate="'required'" data-vv-as="currency">
                                            <el-option label="KES" value="KES"></el-option>
                                            <el-option label="UGX" value="UGX"></el-option>
                                            <el-option label="USD" value="USD"></el-option>
                                            <el-option label="EURO" value="EURO"></el-option>
                                        </el-select>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('currency') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Synonym</strong>
                                        <el-input placeholder="Synonym" v-model="this.editCollections.synonym"
                                            name="synonym" v-validate="'required'" data-vv-as="synonym"></el-input>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('synonym') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>AccountNumber</strong>
                                        <el-input placeholder="AccountNumber" v-model="this.editCollections.accountNumber"
                                            name="accountNumber" v-validate="'required'"
                                            data-vv-as="accountNumber"></el-input>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('accountNumber') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Type</strong>
                                        <el-select v-model="this.editCollections.type" filterable clearable
                                            placeholder="Webapp" class="mb-10" style="width:100%" name="type"
                                            v-validate="'required'" data-vv-as="type">
                                            <el-option label="Mobile" value="Mobile"></el-option>
                                            <el-option label="Bank" value="Bank"></el-option>
                                        </el-select>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('type') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>CollectionProcess</strong>
                                        <el-input type="textarea" v-model="this.editCollections.collectionProcess" autosize
                                            name="collectionProcess" v-validate="'required'"
                                            data-vv-as="collectionProcess"></el-input>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('collectionProcess') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Backoffice Active</strong>
                                        <el-select v-model="this.editCollections.backofficeUse" filterable clearable
                                            placeholder="Backoffice" class="mb-10" style="width:100%" name="backofficeUse"
                                            v-validate="'required'" data-vv-as="backofficeUse">
                                            <el-option label="Active" :value="true"></el-option>
                                            <el-option label="Dormant" :value="false"></el-option>
                                        </el-select>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('backofficeUse') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Webapp Active</strong>
                                        <el-select v-model="this.editCollections.webappUse" filterable clearable
                                            placeholder="Webapp" class="mb-10" style="width:100%" name="webappUse"
                                            v-validate="'required'" data-vv-as="webappUse">
                                            <el-option label="Active" :value="true"></el-option>
                                            <el-option label="Dormant" :value="false"></el-option>
                                        </el-select>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('webappUse') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Mobile Active</strong>
                                        <el-select v-model="this.editCollections.mobileUse" filterable clearable
                                            placeholder="Mobile" class="mb-10" style="width:100%" name="mobileUse"
                                            v-validate="'required'" data-vv-as="mobileUse">
                                            <el-option label="Active" :value="true"></el-option>
                                            <el-option label="Dormant" :value="false"></el-option>
                                        </el-select>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('mobileUse') }}</span>
                                        </transition>
                                    </div>
                                </div>

                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <el-button type="success" class="btn-group" style="width:30%"
                                            @click="editCollectionMode">
                                            <i class="mdi mdi-account-check"></i><span> Edit Provider</span>
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-dialog>


                    <el-dialog :show-close="true" :custom-class="'user-dialog'" :visible="dialogForm2Visible"
                        @close="closeDialog" :before-close="handleClose">
                        <div class="form-box">
                            <div class="row">
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Company Name:</strong>
                                        <el-select v-model="collectionModes.companyID" placeholder="Select company"
                                            filterable clearable class="mb-10" style="width: 100%" @change="companyChanged">
                                            <el-option v-for="company in companyNames" :key="company.id"
                                                :label="company.name" :value="company.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Operating Country:</strong>
                                        <el-select v-model="collectionModes.countryID" filterable clearable
                                            placeholder="Operating Country" autocomplete="off" autofill="off" class="mb-10"
                                            style="width:100%" name="countryID" v-validate="'required'"
                                            data-vv-as="Operating Country" disabled>
                                            <el-option v-for="country in countries" :key="country.id" :label="country.name"
                                                :value="country.id"></el-option>
                                        </el-select>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Name</strong>
                                        <el-input placeholder="Name" v-model="collectionModes.name" name="name"
                                            v-validate="'required'" data-vv-as="name"></el-input>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('name') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Code</strong>
                                        <el-input placeholder="Short Name" v-model="collectionModes.code" name="code"
                                            v-validate="'required'" data-vv-as="code"></el-input>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('code') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Currency</strong>
                                        <el-select v-model="collectionModes.currency" filterable clearable
                                            placeholder="Currency" class="mb-10" style="width:100%" name="currency"
                                            v-validate="'required'" data-vv-as="currency">
                                            <el-option label="KES" value="KES"></el-option>
                                            <el-option label="UGX" value="UGX"></el-option>
                                            <el-option label="USD" value="USD"></el-option>
                                            <el-option label="EURO" value="EURO"></el-option>
                                        </el-select>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('currency') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Synonym</strong>
                                        <el-input placeholder="Synonym" v-model="collectionModes.synonym" name="synonym"
                                            v-validate="'required'" data-vv-as="synonym"></el-input>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('synonym') }}</span>
                                        </transition>
                                    </div>
                                </div>

                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>AccountNumber</strong>
                                        <el-input placeholder="AccountNumber" v-model="collectionModes.accountNumber"
                                            name="accountNumber" v-validate="'required'"
                                            data-vv-as="accountNumber"></el-input>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('accountNumber') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Type</strong>
                                        <el-select v-model="collectionModes.type" filterable clearable placeholder="Webapp"
                                            class="mb-10" style="width:100%" name="type" v-validate="'required'"
                                            data-vv-as="type">
                                            <el-option label="Mobile" value="Mobile"></el-option>
                                            <el-option label="Bank" value="Bank"></el-option>
                                        </el-select>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('type') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>CollectionProcess</strong>
                                        <el-input type="textarea" v-model="collectionModes.collectionProcess" autosize
                                            name="collectionProcess" v-validate="'required'"
                                            data-vv-as="collectionProcess"></el-input>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('collectionProcess') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Backoffice Active</strong>
                                        <el-select v-model="collectionModes.backofficeUse" filterable clearable
                                            placeholder="Backoffice" class="mb-10" style="width:100%" name="backofficeUse"
                                            v-validate="'required'" data-vv-as="backofficeUse">
                                            <el-option label="Active" :value="true"></el-option>
                                            <el-option label="Dormant" :value="false"></el-option>
                                        </el-select>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('backofficeUse') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Webapp Active</strong>
                                        <el-select v-model="collectionModes.webappUse" filterable clearable
                                            placeholder="Webapp" class="mb-10" style="width:100%" name="webappUse"
                                            v-validate="'required'" data-vv-as="webappUse">
                                            <el-option label="Active" :value="true"></el-option>
                                            <el-option label="Dormant" :value="false"></el-option>
                                        </el-select>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('webappUse') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <strong>Mobile Active</strong>
                                        <el-select v-model="collectionModes.mobileUse" filterable clearable
                                            placeholder="Mobile" class="mb-10" style="width:100%" name="mobileUse"
                                            v-validate="'required'" data-vv-as="mobileUse">
                                            <el-option label="Active" :value="true"></el-option>
                                            <el-option label="Dormant" :value="false"></el-option>
                                        </el-select>
                                        <transition name="fade">
                                            <span class="danger-text">{{ errors.first('mobileUse') }}</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="row mt-12">
                                    <div class="col col-md-12">
                                        <el-button type="success" class="btn-group" style="width:30%"
                                            @click="addCollectionModes">
                                            <i class="mdi mdi-account-check"></i><span> Create Provider</span>
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-dialog>
                </div>
            </div>
        </div>
    </vue-scroll>
</template>

<script>
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import $ from 'jquery';

import moment from 'moment';
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/';

export default {
    name: "CollectionModes",
    data() {
        return {
            collectionModesData: [],
            loggedInCompany: [],
            collectionModes: {
                name: "",
                code: "",
                currency: "",
                synonym: "",
                companyID: "",
                countryID: "",
                accountNumber: "",
                type: "",
                collectionProcess: "",
                backofficeUse: false,
                mobileUse: false,
                webappUse: false,
            },
            editCollections: {
                id: "",
                active: "",
                name: "",
                code: "",
                currency: "",
                synonym: "",
                companyID: "",
                countryID: "",
                accountNumber: "",
                type: "",
                collectionProcess: "",
                backofficeUse: false,
                mobileUse: false,
                webappUse: false,
            },
        };
    },
    computed: {
    },
    methods: {
        setPageWidth() {
            this.pageWidth = document.getElementById("page-contacts").offsetWidth;
        },
        __resizeHanlder: _.throttle(function (e) {
            this.setPageWidth();
        }, 700),
        editProvider(data) {
            if (data) {
                this.dialogFormVisible = true;
                this.editCollections = data;
                this.editCollections.id = data.id;
            }
        },
        companyChanged(e) {
            this.companyNames.forEach(cntry => {
                if (cntry.id === e) {
                    this.collectionModes.countryID = cntry.countryID;
                }
            });
        },
        editCollectionMode() {
            if ((this.editCollections.name) && (this.editCollections.id)) {
                this.$confirm('Are you sure to edit this provider?').then(_ => {
                    this.addCollectionMode(this.editCollections).then(result => {
                        if (result) {
                            this.refreshUsers(this.loggedInCompany.id);
                            this.dialogFormVisible = false;
                            this.successMessage('Successifully.');
                        }
                        else {
                            this.errorMessage('Failed');
                        }
                    });
                }).catch(_ => { });
            }
        },


        addProvider() {
            this.dialogForm2Visible = true;
            this.collectionModes.companyID = this.loggedInCompany.id;
            this.collectionModes.countryID = this.loggedInCompany.countryID;
        },

        addCollectionModes() {
            if ((this.collectionModes.name) && (this.collectionModes.currency)) {
                this.$confirm('Are you sure to create this provider?').then(_ => {
                    //this.processingActive();
                    this.addCollectionMode(this.collectionModes).then(result => {
                        if (result) {
                            this.refreshUsers(this.loggedInCompany.id);
                            this.dialogAddFormVisible = false;
                            this.successMessage('Successifully.');
                        }
                        else {
                            this.errorMessage('Failed.');
                        }
                    });
                }).catch(_ => { });
            }
        },


        deleteCollectionModes(id) {
            if (id > 0) {
                this.deleteCollectionMode(id).then((result) => {
                    if (result === true) {
                        this.refreshUsers(this.loggedInCompany.id);
                        this.successMessage('Successifully.');
                    }
                    else {
                        this.errorMessage('Failed.');
                    }
                });
            }
        },

        refreshUsers(companyID) {
            this.startLoader("Getting User Transactions...");
            this.getCollectionModes(companyID)
                .then((result) => {
                    this.collectionModesData = result;
                    this.$nextTick(function () {
                        this.initDt()
                    });
                    this.stopLoader();
                }).catch(err => { this.errorMessage("An Error Occured. " + err); this.stopLoader(); });
        },
        initDt() {
            var tblDT = $('#datatable').DataTable({
                retrieve: true,
                dom: 'Blfrtip',
                "aaSorting": [],
                buttons: [
                    //'print'
                ],
            });
        }
    },
    created() {
        this.startLoader("Loading Data...");
        this.getLoggedInCompany()
            .then((loggedInPartner) => {
                this.loggedInCompany = loggedInPartner;
                this.refreshUsers(0);
                this.getCompanyNames();
                this.getCountries();
                //this.getOperationalCountries();
                this.stopLoader();
            }).catch((err) => {
                this.stopLoader();
                console.log(err);
                this.errorMessage("Failed to load data.");
            });

    },
    mixins: [PermissionsMixins],
};
</script>


<style lang="scss" scoped>
@import "../../assets/scss/_variables";
</style>